import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "navigation-analytics",
  "use": "navigation-analytics-usage",
  "viewBox": "0 0 24 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 22\" id=\"navigation-analytics\"><path d=\"M.75 20.95h22.5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M6 10.45H3a.75.75 0 00-.75.75v9.75h4.5V11.2a.75.75 0 00-.75-.75zM13.5 1.45h-3a.75.75 0 00-.75.75v18.75h4.5V2.2a.75.75 0 00-.75-.75zM21 5.95h-3a.75.75 0 00-.75.75v14.25h4.5V6.7a.75.75 0 00-.75-.75z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/navigation-analytics.svg
// module id = 7Man
// module chunks = 39 44